import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBadge = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 8,
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4C8 6.20914 6.20914 8 4 8C1.79086 8 0 6.20914 0 4Z",
		fill: "#033174"
	})
});
export default SvgBadge;
